<template >
  <div class="container gift_event" v-show="gifts.length != 0">
    <indexTitle english_title="Gift Giving Event" chinese_title="看展送禮活動"></indexTitle>
    <div class="row" style="margin-top: 40px;">
      <div class="gift_event_up col-lg-12">
        <div class="green_bg"></div>
        <div class="gift_event_gift" v-for="gift in gifts.slice(0,4)" :key="gift.id">
          <div class="gift_image_box">
            <img :src="gift.image_url" :alt="gift.title" class="gift_image">
            <div class="gift_info">
              <h3 v-html="gift.title"></h3>
              <p><i class="fa fa-calendar" style="width: 15px;text-align:center;"></i><span v-html="' ' + gift.start_date +'~'+ gift.end_date.slice(5,10)"></span></p>
              <p><i class="fa fa-map-marker" style="width: 15px;text-align:center;"></i><span v-html="' ' + gift.location"></span></p>
              <p><a :href="gift.url" target="_blank">{{gift.button_display}} ⇀</a></p>
            </div>
          </div>
        </div>
      </div>
      <div class="gift_event_down col-lg-12">
        <div class="green_bg"></div>
        <div class="gift_event_gift" v-for="gift in gifts.slice(4,8)" :key="gift.id">
          <div class="gift_image_box">
            <img :src="gift.image_url" :alt="gift.title" class="gift_image">
            <div class="gift_info">
              <h3 v-html="gift.title"></h3>
              <p><i class="fa fa-calendar" style="width: 15px;text-align:center;"></i><span v-html="' ' + gift.start_date +'~'+ gift.end_date.slice(5,10)"></span></p>
              <p><i class="fa fa-map-marker" style="width: 15px;text-align:center;"></i><span v-html="' ' + gift.location"></span></p>
              <p><a :href="gift.url" target="_blank">{{gift.button_display}} ⇀</a></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <moreButton button_text="更多好禮" button_href="gift"></moreButton>
  </div>
</template>

<script>
import IndexTitle from '@/components/index/IndexTitle'
import MoreButton from '@/components/index/MoreButton'

export default {
  name: 'gift_event',
  data () {
    return {
      gifts: [
        // {title: '預約送 文創紙膠帶', start_date: '2018/10/27', end_date: '2018/11/04', location: '桃園展演中心', url: '#', image_url: require('../../assets/gift/gift_01.jpg'), button_display: '立即預約'},
        // {title: '預約送 文創紙膠帶', start_date: '2018/10/27', end_date: '2018/11/04', location: '桃園展演中心', url: '#', image_url: require('../../assets/gift/gift_02.jpg'), button_display: '立即預約'},
        // {title: '預約送 文創紙膠帶', start_date: '2018/10/27', end_date: '2018/11/04', location: '桃園展演中心', url: '#', image_url: require('../../assets/gift/gift_03.jpg'), button_display: '立即預約'},
        // {title: '預約送 文創紙膠帶', start_date: '2018/10/27', end_date: '2018/11/04', location: '桃園展演中心', url: '#', image_url: require('../../assets/gift/gift_04.jpg'), button_display: '立即預約'},
        // {title: '預約送 文創紙膠帶', start_date: '2018/10/27', end_date: '2018/11/04', location: '桃園展演中心', url: '#', image_url: require('../../assets/gift/gift_05.jpg'), button_display: '立即預約'},
        // {title: '預約送 文創紙膠帶', start_date: '2018/10/27', end_date: '2018/11/04', location: '桃園展演中心', url: '#', image_url: require('../../assets/gift/gift_06.jpg'), button_display: '立即預約'},
        // {title: '預約送 文創紙膠帶', start_date: '2018/10/27', end_date: '2018/11/04', location: '桃園展演中心', url: '#', image_url: require('../../assets/gift/gift_07.jpg'), button_display: '立即預約'},
        // {title: '預約送 文創紙膠帶', start_date: '2018/10/27', end_date: '2018/11/04', location: '桃園展演中心', url: '#', image_url: require('../../assets/gift/gift_08.jpg'), button_display: '立即預約'}
      ]
    }
  },
  components: {
     'indexTitle': IndexTitle,
     'moreButton': MoreButton
  },
  computed: {
    API() {
      return process.env.NODE_ENV === 'production' ? 'https://www.top-link.com.tw/' : 'http://localhost/'
    }
  },
  created () {
    var app = this
    var gift_event_api = app.API + 'api/tlweb/activity'
    this.axios
      .get(gift_event_api)
      .then((res) => {
        app.gifts = res.data.data.data
        // console.log('gift data: ', app.gifts);
        if (app.gifts.length <= 5) {
          document.querySelectorAll('.gift_event_down')[0].style.display = 'none'
        }
      })
      .catch((err) => {
        console.log('錯誤:' + err)
    })
  }
}
</script>

<style lang="sass">
$pc-992-media: '992px'
$pad-768-media: '768px'
$mobile-576-media: '576px'

@mixin pc-width() 
  @media (max-width: $pc-992-media)
    @content

@mixin pad-width() 
  @media (max-width: $pad-768-media)
    @content

@mixin mobile-width() 
  @media (max-width: $mobile-576-media)
    @content
  
.green_bg 
  background: #8fc43d
  width: 80%
  height: 150px
  position: absolute
  @include pc-width
    display: none

.gift_event_up
  position: relative
  display: flex
  justify-content: center
  flex-flow: row wrap
  .green_bg 
    left: -30px
    top: -20px
  .gift_event_gift
    /* z-index: 2 */
    width: 25%
    .gift_image_box
      margin: 0 10px
      position: relative
      overflow: hidden
      box-shadow: 0 0 15px grey
      height: 100%
      &:hover 
        .gift_info
          transform: translateY(0)
      img
        width: 100%
        //height: 100% // 防呆用，避免跑版
        display: block
      .gift_info
        position: absolute
        top: 0
        left: 0
        width: 100%
        height: 100%
        background: #efefef
        transform: translateY(100%)
        transition: transform 0.5s
        h3 
          margin: 20px
          font-size: 17px
        p
          font-size: 15px
          &:nth-child(2)
            margin: 30px 0 0 23px
          &:nth-child(3)
            margin-left: 25px
          &:nth-child(4)
            margin: 30px 0 0 25px
            a 
              color: #00a0e9
              text-decoration: none
              font-weight: bold
  @include pc-width
    .gift_event_gift 
      width: 50%
      margin: 10px 0
      .gift_image_box
        box-shadow: 0 0 4px #cfcfcf
        .gift_info
          position: static
          background: white
          transform: none
          padding-left: 10px
          height: auto
          h3
            margin: 15px 0
            font-size: 15px
          p 
            font-size: 13px
            &:nth-child(2)
              margin: 10px 0 0 0
            &:nth-child(3)
              margin: 10px 0
            &:nth-child(4)
              margin: 10px 0
            

.gift_event_down
  position: relative
  display: flex
  justify-content: center
  flex-flow: row wrap
  margin-top: 50px
  .green_bg 
    right: -30px
    top: -20px
  .gift_event_gift
    /* z-index: 2 */
    width: 25%
    .gift_image_box
      margin: 0 10px
      position: relative
      overflow: hidden
      box-shadow: 0 0 15px grey
      height: 100%
      &:hover 
        .gift_info
          transform: translateY(0)
      img
        width: 100%
        //height: 100% // 防呆用，避免跑版
        display: block
      .gift_info
        position: absolute
        top: 0
        left: 0
        width: 100%
        height: 100%
        background: #efefef
        transform: translateY(100%)
        transition: transform 0.5s
        h3 
          margin: 20px
          font-size: 17px
        p
          font-size: 15px
          &:nth-child(2)
            margin: 30px 0 0 23px
          &:nth-child(3)
            margin-left: 25px
          &:nth-child(4)
            margin: 30px 0 0 25px
            a 
              color: #00a0e9
              text-decoration: none
              font-weight: bold
  @include pc-width
    margin-top: 0
    .gift_event_gift 
      width: 50%
      margin: 10px 0
      .gift_image_box
        box-shadow: 0 0 4px #cfcfcf
        .gift_info
          position: static
          background: white
          transform: none
          padding-left: 10px
          height: auto
          h3
            margin: 15px 0
            font-size: 15px
          p 
            font-size: 13px
            &:nth-child(2)
              margin: 10px 0 0 0
            &:nth-child(3)
              margin: 8px 0
            &:nth-child(4)
              margin: 10px 0
</style>
